export const demoIds = [
  'web_articles_antoni_glinda',
  'web_article_laura_aaron',
  'email_brandon_nikki',
  'email_nikki_brandon',
  'education_1',
  'education_2',
  'fantasy_tyler',
  'fantasy_grandpa',
  'selfhelp_rob',
  'selfhelp_sarah',
  'romance_orus',
  'romance_jessica',
  'religious_algieba',
  'religious_umbriel',
  'truecrime_jax',
  'truecrime_simeon',
] as const;

export type DemoId = (typeof demoIds)[number];

export const DEMO_PAIRS = {
  web: ['web_articles_antoni_glinda', 'web_article_laura_aaron'],
  email: ['email_brandon_nikki', 'email_nikki_brandon'],
  education: ['education_1', 'education_2'],
  ebooks: ['fantasy_tyler', 'fantasy_grandpa'],
  selfhelp: ['selfhelp_rob', 'selfhelp_sarah'],
  romance: ['romance_orus', 'romance_jessica'],
  religious: ['religious_algieba', 'religious_umbriel'],
  truecrime: ['truecrime_jax', 'truecrime_simeon'],
} as const satisfies Record<string, readonly DemoId[]>;

export type DemoPairKey = keyof typeof DEMO_PAIRS;
